import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	googleDocsLabel: {
		id: 'dynamic-cards-search-page.document-search-result.google-docs-label',
		defaultMessage: 'Docs',
		description: 'Google Docs subtype label',
	},
	googleSlidesLabel: {
		id: 'dynamic-cards-search-page.document-search-result.google-slides-label',
		defaultMessage: 'Slides',
		description: 'Google Slides subtype label',
	},
	googleSheetsLabel: {
		id: 'dynamic-cards-search-page.document-search-result.google-sheets-label',
		defaultMessage: 'Sheets',
		description: 'Google Sheets subtype label',
	},
	msWordLabel: {
		id: 'dynamic-cards-search-page.document-search-result.ms-word-label',
		defaultMessage: 'Word',
		description: 'Microsoft Word subtype label',
	},
	msPowerpointLabel: {
		id: 'dynamic-cards-search-page.document-search-result.ms-powerpoint-label',
		defaultMessage: 'PowerPoint',
		description: 'Microsoft PowerPoint subtype label',
	},
	msExcelLabel: {
		id: 'dynamic-cards-search-page.document-search-result.ms-excel-label',
		defaultMessage: 'Excel',
		description: 'Microsoft Excel subtype label',
	},
});
